import React, { createContext, useContext, useState } from 'react'

interface NotificationContextData {
  toggleNotification: () => void
  isOpen: boolean
}

// eslint-disable-next-line
const NotificationContext = createContext<NotificationContextData>({} as NotificationContextData);

function NotificationProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  return (
    <NotificationContext.Provider
      value={{ isOpen, toggleNotification: toggle }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

function useNotification(): NotificationContextData {
  const context = useContext(NotificationContext)

  if (!context) {
    throw new Error(
      'useNotification must be used within an NotificationProvider',
    )
  }

  return context
}

export { NotificationProvider, useNotification }
